import Box, { BoxProps } from './Box';

export type BoxStyleProps = BoxProps;

export default Box;
